import Phaser from 'phaser';

export type SfxKey = 'footstep' | 'interactSwing' | 'interactHit' | 'jump' | 'land';

export class AudioManager {
  private sound: Phaser.Sound.BaseSoundManager;
  private cache = new Map<SfxKey, Phaser.Sound.BaseSound>();

  constructor(sound: Phaser.Sound.BaseSoundManager) {
    this.sound = sound;
  }

  register(key: SfxKey, assetKey: string): void {
    if (!this.sound.game.cache.audio.exists(assetKey)) return;
    const s = this.sound.add(assetKey);
    this.cache.set(key, s);
  }

  play(key: SfxKey, config?: Phaser.Types.Sound.SoundConfig): void {
    const s = this.cache.get(key);
    if (!s) return;
    if (s.isPlaying) s.stop();
    s.play(config);
  }

  dispose(): void {
    for (const s of this.cache.values()) s.destroy();
    this.cache.clear();
  }
}